(() => {
  const update = (variant) => {
    const el = document.querySelector('.ibscent-pdp__priceper');
    if (!el || !variant) return;
    const match = String(variant.title || '').match(/(\d+(?:\.\d+)?)\s*ml/i);
    if (!match) {
      el.hidden = true;
      return;
    }
    const ml = parseFloat(match[1]);
    if (!ml) {
      el.hidden = true;
      return;
    }
    const perMl = variant.price / 100 / ml;
    el.hidden = false;
    el.textContent = '$' + perMl.toFixed(2) + '/ML';
  };

  const updateSave = (variant) => {
    const el = document.querySelector('[data-pdp-save]');
    if (!el || !variant) return;
    const price = variant.price;
    const compare = variant.compare_at_price;
    if (compare && compare > price) {
      const pct = Math.round(((compare - price) / compare) * 100);
      el.textContent = 'You save ' + pct + '%';
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  };

  document.addEventListener('variant:change', (event) => {
    const variant = event.detail && event.detail.variant;
    update(variant);
    updateSave(variant);
  });
})();
